import React from 'react';
import '../../../App.css';
import HeroSection from '../../Heros/HeroSection';
import HeroImmunoClust from "./HeroImmunoClust";
import GoToDemoSection from "./GoToDemoSection";
import CustomHorizontalSpace from "../../Assistants/SpaceAssistant";


function Home() {
    return (
        <>
            <HeroSection />
            <CustomHorizontalSpace space={100}/>
            <HeroImmunoClust/>
            <CustomHorizontalSpace space={200}/>
            <GoToDemoSection/>
            <CustomHorizontalSpace space={150}/>
        </>
    );
}

export default Home;